import { JobApplicationFieldsSharedModule } from './component/fields/jobapplication-fields-shared.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; // for using ngModel directive
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { PanelModule } from 'primeng/panel';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { HisSharedModule } from 'hisng';

import { JobApplicationFormComponent } from './component/create/jobapplication-form.component';
import { JobApplicationOverviewComponent } from './component/create/jobapplication-overview.component';
import { JobApplicationSuccessComponent } from './component/create/jobapplication-success.component';
import { JobApplicationPageComponent } from './component/create/jobapplication-page.component';

/**
 * SharedModule for jobapplications.
 */
@NgModule( {
    imports: [
        // Angular
        CommonModule,
        FormsModule,
        RouterModule,

        // PrimeNG
        AutoCompleteModule,
        PanelModule,
        FileUploadModule,
        TableModule,
        DialogModule,
        OverlayPanelModule,

        // HIS
        HisSharedModule,

        JobApplicationFieldsSharedModule,
    ],

    declarations: [
        JobApplicationFormComponent,
        JobApplicationOverviewComponent,
        JobApplicationSuccessComponent,
        JobApplicationPageComponent,
    ],

    exports: [
        JobApplicationFormComponent,
        JobApplicationOverviewComponent,
        JobApplicationSuccessComponent,
        JobApplicationPageComponent
    ]

    // NO PROVIDERS! Providers need to go into JobApplicationCoreModule
} )
export class JobApplicationSharedModule {
}
